<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <!-- Content -->

    <mat-horizontal-stepper style="height: 100%" linear="true" #stepper>
        <mat-step [stepControl]="firstFormGroup">
            <form [formGroup]="firstFormGroup">
                <ng-template matStepLabel>{{ "Info" | translate }}</ng-template>
                <div fxLayout="row" fxLayoutAlign="end center">
                    <mat-label>{{
                        "*Campos Obligatorios" | translate
                        }}</mat-label>
                </div>
                <mat-label>{{ "Nombre de la Campaña" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder=""
                        [readonly]="action === recordAction.View" required />
                </mat-form-field>
                <mat-label>{{ "Codigo Corto" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-select [compareWith]="compareFn" name="shortcode" formControlName="shortcode"
                        [disabled]="action === recordAction.View" placeholder="" required>
                        <mat-option *ngFor="let shortCode of shortCodes" [value]="shortCode">{{
                            shortCode.operator.name +
                            " - " +
                            shortCode.value
                            }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-label>{{ "Grupos" | translate }}*</mat-label>
                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-select [compareWith]="compareFn" name="grupo" [disabled]="action === recordAction.View"
                        formControlName="grupo" placeholder="" multiple>
                        <mat-option *ngFor="let grupo of grupos" [value]="grupo">{{ grupo.name }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <section class="tracking-container">
                    <mat-label>{{ "Tracking MO" | translate }}</mat-label>
                    <mat-slide-toggle name="istracking" formControlName="istracking"></mat-slide-toggle>
                </section>

                <div>
                    <button class="next-button" mat-button matStepperNext>
                        <span class="material-icons-outlined">
                            arrow_forward_ios
                        </span>
                        {{ "Siguiente" | translate }}
                    </button>
                </div>
            </form>
        </mat-step>

        <mat-step [stepControl]="secondFormGroup">
            <form [formGroup]="secondFormGroup">
                <div fxLayout="row" fxLayoutAlign="end center">
                    <mat-label>{{
                        "*Campos Obligatorios" | translate
                        }}</mat-label>
                </div>
                <ng-template matStepLabel>SAT</ng-template>
                <div *ngIf="action !== recordAction.View" fxLayoutAlign="end" class="pt-12">
                    <button mat-stroked-button class="add-tab-button" (click)="addTab()">
                        {{ "Agregar" | translate }}
                        <span class="material-icons-outlined"> add </span>
                    </button>
                </div>

                <mat-tab-group style="margin-top: 3px" class="sat-tab-group" [selectedIndex]="selected.value"
                    (selectedIndexChange)="selected.setValue($event)">
                    <mat-tab formArrayName="items" class="mat-tab-body-content-sat"
                        *ngFor="let tab of tabs; let index = index">
                        <ng-template mat-tab-label>
                            {{ tab }}
                            <button *ngIf="action !== recordAction.View" mat-icon-button (click)="removeTab(index)">
                                <span class="material-icons-outlined">
                                    highlight_off
                                </span>
                            </button>
                        </ng-template>

                        <div [formGroupName]="index">
                            <mat-label>{{ "Mensaje SAT" | translate }}*</mat-label>
                            <mat-form-field appearance="outline" class="w-100-p">
                                <textarea matInput #input maxlength="150" name="message" formControlName="message"
                                    [readonly]="action === recordAction.View" placeholder="" required></textarea>
                                <mat-hint align="end">{{
                                    input.value?.length || 0
                                    }}/150</mat-hint>
                            </mat-form-field>
                            <mat-label>{{ "Acciones" | translate }}</mat-label>
                            <mat-form-field appearance="outline" class="w-100-p">
                                <mat-select (change)="radioChange($event, index)" [(value)]="checkedRadioButton[index]"
                                    name="acciones" [disabled]="action === recordAction.View" placeholder="">
                                    <mat-option *ngFor="let accion of acciones" [value]="accion.id">{{ accion.name
                                        }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <div style="
                                    height: 135px;
                                    padding: 0px 5px;
                                    margin-bottom: 3px;
                                ">
                                <div *ngIf="checkedRadioButton[index] === 2">
                                    <mat-label>{{ "Para:" | translate }}*</mat-label>
                                    <mat-form-field appearance="outline" class="w-100-p">
                                        <input matInput name="para" formControlName="para" mat-maxlength="50"
                                            placeholder="" [readonly]="
                                                action === recordAction.View
                                            " />
                                    </mat-form-field>
                                    <mat-label>{{
                                        "Contenido:" | translate
                                        }}*</mat-label>
                                    <mat-form-field appearance="outline" class="w-100-p">
                                        <input matInput name="contenido" formControlName="contenido" mat-maxlength="50"
                                            placeholder="" [readonly]="
                                                action === recordAction.View
                                            " />
                                    </mat-form-field>
                                </div>

                                <!--   <div *ngIf="checkedRadioButton[index] === 2">

                                        <mat-form-field class="w-100-p">
                                            <mat-select  name="para" formControlName="para"
                                                [disabled]="action===recordAction.View" placeholder="Para:" >
                                                <mat-option *ngFor="let shortCode of shortCodes_abanico" [value]="shortCode.value">{{shortCode.value}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field class="w-100-p">
                                            <mat-select   name="contenido" formControlName="contenido"
                                                [disabled]="action===recordAction.View" placeholder="Contenido:" >
                                                <mat-option *ngFor="let shortCodeKeyword of shortCodesKeywords" [value]="shortCodeKeyword.regex">{{shortCodeKeyword.short_code
                                                    + ' - ' + shortCodeKeyword.regex}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div> -->

                                <div *ngIf="checkedRadioButton[index] === 3">
                                    <mat-label>{{
                                        "Texto a mostrar:" | translate
                                        }}*</mat-label>
                                    <mat-form-field appearance="outline" class="w-100-p">
                                        <input matInput name="textoamostrar" formControlName="textoamostrar"
                                            mat-maxlength="50" placeholder="" [readonly]="
                                                action === recordAction.View
                                            " />
                                    </mat-form-field>
                                    <mat-label>{{ "Url:" | translate }}*</mat-label>
                                    <mat-form-field appearance="outline" class="w-100-p">
                                        <input matInput name="url" formControlName="url" mat-maxlength="50"
                                            placeholder="" [readonly]="
                                                action === recordAction.View
                                            " />
                                    </mat-form-field>
                                </div>

                                <div *ngIf="checkedRadioButton[index] === 4">
                                    <mat-label class="w-40-p">{{
                                        "Longitud Minima del Input:"
                                        | translate
                                        }}*</mat-label>
                                    <mat-form-field appearance="outline" class="w-100-p">
                                        <input type="number" matInput name="min" formControlName="min" placeholder=""
                                            [readonly]="
                                                action === recordAction.View
                                            " />
                                    </mat-form-field>
                                    <mat-label class="w-40-p">{{
                                        "Longitud Maxima del Input:"
                                        | translate
                                        }}*</mat-label>
                                    <mat-form-field appearance="outline" class="w-100-p">
                                        <input type="number" matInput name="max" formControlName="max" placeholder=""
                                            [readonly]="
                                                action === recordAction.View
                                            " />
                                    </mat-form-field>
                                    <mat-label>{{
                                        "Marcación:" | translate
                                        }}*</mat-label>
                                    <mat-form-field appearance="outline" class="w-100-p">
                                        <input matInput name="para2" formControlName="para2" mat-maxlength="50"
                                            placeholder="" [readonly]="
                                                action === recordAction.View
                                            " />
                                        <!--  <mat-select name="para2" formControlName="para2" [disabled]="action===recordAction.View"
                                            placeholder="Marcación">
                                            <mat-option *ngFor="let shortCode of shortCodes_abanico" [value]="shortCode.value">{{shortCode.value}}</mat-option>
                                        </mat-select> -->
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>

                <div class="buttons-container">
                    <button class="back-button" mat-stroked-button matStepperPrevious>
                        <span class="material-icons-outlined">
                            arrow_back_ios
                        </span>
                        {{ "Anterior" | translate }}
                    </button>
                    <button class="save-button" mat-button matStepperNext>
                        <span class="material-icons-outlined">
                            arrow_forward_ios
                        </span>
                        {{ "Siguiente" | translate }}
                    </button>
                </div>
            </form>
        </mat-step>

        <mat-step [stepControl]="thirdFormGroup">
            <form [formGroup]="thirdFormGroup">
                <div fxLayout="row" fxLayoutAlign="end center">
                    <mat-label>{{
                        "*Campos Obligatorios" | translate
                        }}</mat-label>
                </div>
                <ng-template matStepLabel>{{
                    "Calendarizar" | translate
                    }}</ng-template>

                <mat-checkbox (change)="esRecurrenteChecked($event)" name="esRecurrente"
                    formControlName="esRecurrente">{{ "Recurrente" | translate }}</mat-checkbox>

                <section class="example-section">
                    <mat-label>{{ "Fecha de Inicio" | translate }}*</mat-label>
                    <mat-form-field appearance="outline" class="w-100-p">
                        <input formControlName="fechaInicio" matInput [matDatepicker]="picker" placeholder=""
                            [readonly]="action === recordAction.View" />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-label *ngIf="esRecurrente">{{ "Fecha Final" | translate }}*</mat-label>
                    <mat-form-field appearance="outline" *ngIf="esRecurrente" class="w-100-p">
                        <input formControlName="fechaFin" matInput [matDatepicker]="picker2" placeholder=""
                            [readonly]="action === recordAction.View" />
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </section>
                <mat-label>{{ "Hora de envio" | translate }}*</mat-label>
                <section class="example-section-time">
                    <mat-form-field appearance="outline" class="w-70-p">
                        <input matInput type="time" name="time" formControlName="time" mat-maxlength="50" placeholder=""
                            [readonly]="action === recordAction.View" />
                    </mat-form-field>
                    <div class="tracking-container">
                        <mat-label>{{ "Activo" | translate }}</mat-label>
                        <mat-slide-toggle name="esActivo" formControlName="esActivo"></mat-slide-toggle>
                    </div>
                </section>
                <div style="height: 45px !important">
                    <section *ngIf="esRecurrente" class="example-section">
                        <mat-radio-group>
                            <mat-radio-button (change)="radioChangeRecurrent($event)"
                                [checked]="checkedRadioButon === 1" class="example-margin" value="1">{{
                                "Todos los dias" | translate
                                }}</mat-radio-button>
                            <mat-radio-button (change)="radioChangeRecurrent($event)"
                                [checked]="checkedRadioButon === 3" class="example-margin" value="3">{{
                                "Dias Especificos" | translate
                                }}</mat-radio-button>
                        </mat-radio-group>
                    </section>
                </div>

                <div style="height: 110px !important">
                    <section *ngIf="checkedRadioButon === 3">
                        <section class="example-section-days">
                            <div style="width: 42%">
                                <mat-checkbox name="lunes" formControlName="lunes" class="example-margin">{{ "Lunes" |
                                    translate }}</mat-checkbox>
                                <mat-checkbox name="jueves" formControlName="jueves" class="example-margin">{{ "Jueves"
                                    | translate }}</mat-checkbox>
                                <mat-checkbox name="domingo" formControlName="domingo" class="example-margin">{{
                                    "Domingo" | translate }}</mat-checkbox>
                            </div>
                            <div>
                                <mat-checkbox name="martes" formControlName="martes" class="example-margin">{{ "Martes"
                                    | translate }}</mat-checkbox>
                                <mat-checkbox name="viernes" formControlName="viernes" class="example-margin">{{
                                    "Viernes" | translate }}</mat-checkbox>
                            </div>

                            <div>
                                <mat-checkbox name="miercoles" formControlName="miercoles" class="example-margin">{{
                                    "Miércoles" | translate }}</mat-checkbox>
                                <mat-checkbox name="sabado" formControlName="sabado" class="example-margin">{{ "Sábado"
                                    | translate }}</mat-checkbox>
                            </div>
                        </section>
                    </section>
                </div>

                <div class="buttons-container">
                    <button class="back-button" mat-stroked-button matStepperPrevious>
                        <span class="material-icons-outlined">
                            arrow_back_ios
                        </span>
                        {{ "Anterior" | translate }}
                    </button>
                    <button class="save-button" [spinnerButton]="isWaiting" *ngIf="action !== recordAction.View"
                        mat-raised-button (click)="performAction()">
                        <span class="material-icons-outlined"> save </span>
                        {{ "Guardar" | translate }}
                    </button>
                </div>
            </form>
        </mat-step>
    </mat-horizontal-stepper>
    <!-- Content -->

    <!-- Buttons
            <button  mat-raised-button (click)="performAction()" class="save-button mat-accent" [disabled]="satForm.invalid" aria-label="Enviar">
                Enviar
            </button>
    -->

    <!-- Buttons -->
</wtf-dialogcontent>